<!--
 * @Descripttion: 图标选择器组件
 * @version: 1.0.0
 * @Author: kun.zhang
 * @Date: 2021-09-01 11:20:53
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2022-01-06 15:10:59
-->
<template>
  <div class="svg_wrap">
    <div v-for="item in svgList" :key="item.icon" class="svg_item" @click="svgSelected(item)">
      <svg-icon :icon-class="item.icon"></svg-icon>
      <!-- <p class="svg_label">{{ item.label }}</p> -->
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/common/SvgIcon";
import { svgList, workBenchList } from "@/assets/svg/svg-list.js";

export default {
  name: "IconPicker",
  components: {
    SvgIcon
  },
  props: {
    category: {
      type: String,
      default: "menu"
    }
  },
  data() {
    return {
      svgList
    };
  },
  created() {
    if (this.category !== "menu") {
      this.svgList = workBenchList;
    }
  },
  methods: {
    svgSelected(data) {
      this.$emit("handleIconSelected", data.icon);
    }
  }
};
</script>

<style lang="scss" scoped>
.svg_wrap {
  height: 100%;
  line-height: normal;
  overflow: auto;

  .svg_item {
    float: left;
    padding: 4px;
    width: 50px;
    height: 40px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;

    .svg_label {
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin-top: 6px;
    }
  }
}
.svg-icon {
  width: 1.2em;
  height: 1.2em;
}
</style>
